import { AsYouType, getCountries, getCountryCallingCode } from 'libphonenumber-js';
import { useMemo } from 'react';
import type { CountryCode } from '@/constants/country';

/**
 * ("81", "0312345678") -> countryCode: "JP", "+81 03-1234-5678"
 */
export function useFormattedPhoneNumber(value?: {
  dialCode?: string;
  phoneNumber?: string;
}) {
  return useMemo(() => {
    const countryCode = getCountries().find(code => getCountryCallingCode(code) === value?.dialCode) ?? null;
    const formatter = countryCode ? new AsYouType(countryCode as CountryCode) : null;
    const formattedNumber = formatter ? formatter.input(value?.phoneNumber ?? '') : value?.phoneNumber ?? '';
    return {
      countryCode,
      formattedNumber,
      formattedFull: `+${value?.dialCode} ${formattedNumber}`
    };
  }, [value?.dialCode, value?.phoneNumber]);
}